import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=96fcd4f2&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=96fcd4f2&prod&langs=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fcd4f2",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/SidebarPlugin/SidebarItem.vue
// module id = 1459
// module chunks = 31